import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { Subject } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IntegrationsDataProvider } from '@services/integrations/integrations.data.service';
import { finalize, takeUntil } from 'rxjs/operators';

@Component({
	selector: 'integrate-xero-modal',
	template: require('./integrate-xero-modal.html')
})
export class IntegrateXeroModal implements OnInit, OnDestroy {
	@Input() accountList;

	button_disabled: boolean;
	chosenPaymentAccount;
	chosenRevenueAccount;
	enablePaymentsCopying;

	private unsubscribe: Subject<void> = new Subject();

	constructor(
		public activeModal: NgbActiveModal,
		private messageService: MessageService,
		private integrationDataService: IntegrationsDataProvider
	) {}

	ngOnInit(): void {
		this.setXeroAccounts();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	setXeroAccounts(): void {
		const {
			currentPaymentAccountId,
			currentRevenueAccountId,
			paymentAccounts,
			revenueAccounts
		} = this.accountList;

		this.chosenPaymentAccount = currentPaymentAccountId
			? paymentAccounts.find(account => account.key === currentPaymentAccountId)
			: paymentAccounts[0];

		this.chosenRevenueAccount = currentPaymentAccountId
			? revenueAccounts.find(account => account.key === currentRevenueAccountId)
			: revenueAccounts[0];

		this.enablePaymentsCopying = !!currentPaymentAccountId;
	}

	successSetAccount(): void {
		this.activeModal.close();
		this.messageService.showToaster('s_0', 'xero');
	}

	gatherData2Save(): object {
		const accounts = {
			revenueAccount: this.chosenRevenueAccount.key,
			paymentAccount: this.chosenPaymentAccount.key,
			enablePaymentsCopying: this.enablePaymentsCopying
		};
		return accounts;
	}

	changePathAfterIntegration(): void {
		this.button_disabled = false;
		window.history.replaceState(
			null,
			null,
			window.location.pathname.replace('/xero', '')
		);
	}

	saveXeroSettings(): void {
		this.button_disabled = true;
		const data = this.gatherData2Save();
		const {
			currentPaymentAccountId,
			currentRevenueAccountId
		} = this.accountList;
		const isSettingsToUpdate =
			currentPaymentAccountId || currentRevenueAccountId;

		if (isSettingsToUpdate) {
			this.integrationDataService
				.editXeroSettingsById(data)
				.pipe(takeUntil(this.unsubscribe))
				.subscribe(() => {
					this.successSetAccount();
				});
		} else {
			this.integrationDataService
				.createXeroSettings(data)
				.pipe(
					finalize(() => this.changePathAfterIntegration()),
					takeUntil(this.unsubscribe)
				)
				.subscribe(() => {
					this.successSetAccount();
				});
		}
	}

	onDismiss(): void {
		this.changePathAfterIntegration();
		this.activeModal.close();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/settings/integrations-section/modals/integrate-xero-modal/integrate-xero-modal.ts